import React from "react";

function VideoCard({ video }) {
  return (
    <div
      onClick={() => window.open(video.url, "_blank")}
      style={{
        cursor: "pointer",
        borderRadius: "15px",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-5px)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.25)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
      }}
    >
      {/* Thumbnail */}
      <div style={{ position: "relative" }}>
        <img
          src={video.thumbnail}
          alt={video.title}
          style={{
            width: "100%",
            height: "200px",
            objectFit: "cover",
          }}
        />

        {/* Play Icon */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "65px",
            height: "65px",
            borderRadius: "50%",
            background: "rgba(255,0,0,0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            fontSize: "30px",
          }}
        >
          ▶
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: "15px" }}>
        <h3
          style={{
            margin: "0",
            fontSize: "18px",
            color: "#222",
            marginBottom: "8px",
          }}
        >
          {video.title}
        </h3>

        <p
          style={{
            margin: "0",
            color: "#666",
            fontSize: "14px",
          }}
        >
          📺 K-Mech EduNet
        </p>

        <button
          style={{
            marginTop: "15px",
            width: "100%",
            background: "#ff0000",
            color: "#fff",
            border: "none",
            padding: "10px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "15px",
            fontWeight: "bold",
          }}
        >
          ▶ Watch Video
        </button>
      </div>
    </div>
  );
}

export default VideoCard;

